var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustratorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:#4d8c9f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M43.1,0H6.9C3.09,0,0,3.09,0,6.9V43.1c0,3.81,3.09,6.9,6.9,6.9H43.1c3.81,0,6.9-3.09,6.9-6.9V6.9C50,3.09,46.91,0,43.1,0Zm-12.33,37.75h-3.63l-.29-.23-2.08-6.64h-7.43l-1.98,6.56c-.03,.23-.13,.3-.32,.3h-3.31c-.23,0-.29-.12-.23-.38,1.75-5.77,4.71-15.39,6.78-21.91,.1-.38,.19-.76,.26-2.08l.2-.22h4.47l.26,.19c2.4,7.73,5.03,16.26,7.49,24.06,.06,.22,0,.34-.2,.34Zm7.56-.31l-.25,.3h-3.32c-.19,0-.29-.07-.29-.34V19.71c0-.22,.07-.3,.22-.3h3.38c.19,0,.25,.04,.25,.3v17.73Zm-1.94-20.52c-1.27,0-2.13-.9-2.13-2.34s.92-2.34,2.16-2.34c1.31,0,2.11,.94,2.11,2.34s-.86,2.34-2.14,2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M20.97,16.93c-.49,2.49-1.82,6.75-2.79,10.26h5.71c-.65-2.53-2.24-7.62-2.89-10.26h-.03Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratorIcon);
export default __webpack_public_path__ + "static/media/illustrator-icon.8ab39cfa1de347b66c2bf7715fc9263b.svg";
export { ForwardRef as ReactComponent };